<template>
  <div style="max-width: 400px" class="mx-auto">
    <v-divider><span class="text-disabled" v-text="$t('auth.loginWithSocials')"></span></v-divider>
    <div class="py-5">
      <SocialLoginWrapper/>
    </div>

    <v-divider><span class="text-disabled" v-text="$t('auth.orUserNameAndPassword')"></span></v-divider>
    <div class="py-5">
      <v-form  ref="form" class="mx-auto d-flex justify-center flex-wrap" v-model="valid">
        <v-text-field
            autofocus
            style="width:200px"
            :label="$t('user.email')"
            type="email"
            v-model="user.email"
            required
        />
        <v-text-field :label="$t('password')"
                      v-model="user.password"
                      style="width:100%"
                      autocomplete
                      @keydown.enters="handleLogin"
                      :rules="passwordRules"
                      type="password"
                      required
        />

        <v-btn color="accent" class="mx-auto align-self-center" :loading="loading" block :disabled="!valid" @click="handleLogin">
          <span>Login</span>
        </v-btn>

        <v-btn block class="mt-4 my-2" variant="plain" href="/u/reset/password/request">{{$t('auth.forgotPassword')}}</v-btn>
        <v-btn block class="" variant="plain" href="/login/register">{{$t('auth.createAccount')}}</v-btn>
        <NotificationSnackbar @click="message=null" v-if="message" :notification="notification"/>
      </v-form>
    </div>



</div>
</template>

<script>

import {useAuthUserStore} from "@/stores/modules/auth.module";
import NotificationSnackbar from "@/components/notification/NotificationSnackbar";
import NotificationElephant from "@/models/notification";
import LottieAnimation from "@/components/LottieAnimation.vue";
import SocialLoginWrapper from "@/components/auth/socialLogin/SocialLoginWrapper.vue";
export default {
  name: 'LoginForm',
  components: {SocialLoginWrapper,  LottieAnimation, NotificationSnackbar},
  setup () {
    const authUserStore = useAuthUserStore()

    return {
      // you can also access the whole store in your component by returning it
      authUserStore,
    }
  },

  data() {
    return {

      valid: true,
      user: {
        email:'',
        password:''
      },
      message: '',
      loading:false,
      username:'',
      usernameRules:[
        v => !!v || "Bitte geben Sie Ihre Email-Adresse an.",
      ],
      required: v => !!v || "Dieses Feld ist Pflicht",
      password:'',
      confirmPassword:"",
      passwordRules:
          [
            v => !!v || "Bitte geben Sie Ihr Passwort ein.",

          ]

    };
  },
  computed: {
    from() {
      return this.$route.query.from;
    },
    notification(){
      return new NotificationElephant({title:this.message.title,message:this.message.message,color:'ERROR'})
    },
    frontendhost(){
      return process.env.VUE_APP_FRONTHOST;
    },
    loggedIn() {
      return this.authUserStore.status.loggedIn;
    }
  },
  created() {
    if (this.loggedIn) {
      this.$router.push('/');
    }
  },
  methods: {

    handleLogin() {
      this.loading = true;
      /**
       this.$validator.validateAll().then(isValid => {
       if (!isValid) {
       this.loading = false;
       return;
       }
       **/
      if (this.user.email && this.user.password) {
        this.authUserStore.login(this.user).then(
            () => {
              //location.href = '/';
              if(this.authUserStore.user?.languageCode) this.$i18n.locale = this.authUserStore.user.languageCode;

              this.loading=false;
              if (this.from) location.href = this.from;
              else location.href = "/";
            },
            (error) => {

              this.loading = false;
              if(error.response) this.message = error.response.data;
              else this.message="unbekannter Fehler";
              setTimeout(()=>{
                this.message=null;
              },20000);
            }
        );
      }

    }
  }
};
</script>
<style>

</style>
